import React, { memo } from 'react';
import { getImageUrl } from './get-image-url';
import { BgPictureContainer, ThumbnailContainer, ThumbnailImage } from './styles';
var ThumbnailImageComponent = function (_a) {
    var image = _a.image, onClick = _a.onClick, imageBorder = _a.imageBorder, imageBorderRadius = _a.imageBorderRadius;
    var imageUrls = {
        small: getImageUrl('small-mobile', image),
        medium: getImageUrl('medium-mobile', image),
        large: getImageUrl('large-mobile', image),
        desktop: getImageUrl('desktop', image),
        wideScreen: getImageUrl('wide-screen', image),
    };
    return (React.createElement(ThumbnailContainer, { onClick: onClick, imageBorder: imageBorder, imageBorderRadius: imageBorderRadius },
        React.createElement(BgPictureContainer, null,
            imageUrls.large && React.createElement("source", { media: "(min-width:480px)", srcSet: imageUrls.large }),
            imageUrls.medium && React.createElement("source", { media: "(min-width:320px)", srcSet: imageUrls.medium }),
            imageUrls.small && (React.createElement(ThumbnailImage, { alt: image.caption, src: imageUrls.small, imageBorder: imageBorder, imageBorderRadius: imageBorderRadius, loading: "lazy", decoding: "async" })))));
};
export default memo(ThumbnailImageComponent);
